import type { MessageLogsListParams, MessageLogsSortKey } from '../../types/pages'

export const DEFAULT_MESSAGE_LOGS_PARAMS: MessageLogsListParams = {
  page: 1,
  perPage: 15,
  sortBy: 'desc',
  orderBy: 'created_at',
  q: '',
  delivered: '',
  fromDt: '',
  toDt: '',
}

export const MESSAGE_LOGS_SORT_COLUMNS: { key: MessageLogsSortKey; label: string }[] = [
  { key: 'fk_applicant_id', label: 'Applicant' },
  { key: 'id', label: 'Id' },
  { key: 'to', label: 'To' },
  { key: 'body', label: 'Body' },
  { key: 'delay', label: 'Delay' },
  { key: 'error_code', label: 'Status' },
  { key: 'error_code', label: 'Error Code' },
  { key: 'error_message', label: 'Error Message' },
  { key: 'sent_at', label: 'Sent Time' },
]
